<template>
  <div class="slideshow">
    <div class="slideshow__body">
      <div class="slideshow__main">
        <swiper v-if="slidesMain && slidesMain.length > 0" :options="optionsSliderMain" ref="swiper_slideshow">
          <swiperSlide 
            class="item position-rel" 
            v-for="(item, index) of slidesMain" 
            :key="`book__${index}`"
          >
            <div class="item__wrap position-rel bg-color-light">
              <div class="item__img">
                <img v-if="item.imageBase64" :src="`${base64Define}${item.imageBase64}`" class="full-width" alt="">
                <!-- <img v-else-if="item.imageUrl" :src="`${baseUrl}/${item.imageUrl}`" class="full-width" alt=""> -->
                <img v-else-if="item.imageUrl && isFullLink(item.imageUrl)" :src="item.imageUrl" class="full-width" alt="">
                <img v-else-if="item.imageUrl && !isFullLink(item.imageUrl)" :src="`${baseUrl}/${item.imageUrl}`" class="full-width" alt="">
              </div>
              <div class="item__media">
                <div
                  v-for="(link, pos) of item.items"
                  :key="pos"
                  v-show="link.type === 'audio' || link.type === 'video'"
                  class="item__link"
                  style="position: absolute;z-index: 1;"
                  :style="renderStyleLink(link)"
                  @click="handleViewMedia(link)"
                ></div>
              </div>
            </div>
          </swiperSlide>
        </swiper>
      </div>
    </div>
    <div class="slideshow__footer modal-p-lr-35 display-flex-center justify-content-between color_bg_gray_light">
      <a
        href="javascript:;"
        class="primary-color font-size-16 font-sanpro-semibold book-viewer__footer__cats border-rd-20 position-rel display-flex-center justify-content-center"
        @click="closeSlideshow"
      >
        <i class="icon-close font-size-14"></i> 
        <span class="only-pc">Đóng</span>
      </a>
      <div class="pre-pare-detail__footer__center">
        <div class="pre-pare-detail__paging display-flex-center">
          <button class="btn btn-main border-rd-20 display-flex-center justify-content-center slideshow__prev" @click="prevSlide()">
            <i class="icon-prev color-light font-size-18"></i>
          </button>
          <span class="pre-pare-detail__paging__num display-flex-center justify-content-center bg-color-light border-rd-20 secondary-color-txt">
            {{slideIndexVisible + 1}}/{{slidesMain.length}}
          </span>
          <button class="btn btn-main border-rd-20 display-flex-center justify-content-center slideshow__next" @click="nextSlide()">
            <i class="icon-next color-light font-size-18"></i>
          </button>
        </div>
      </div>
      <div class="pre-pare-detail__footer__end">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { STORE_KEY, BASE_64_DEFINE } from './../../_store/constants'
import { APP_CONFIG } from '@/utils/constants'
import mixinsFiles from '@/components/content-files/mixinsFiles'

export default {
  name: 'Slideshow',
  mixins: [ mixinsFiles ],
  components: {
    swiper, 
    swiperSlide
  },
  data () {
    return {
      currLinkIndex: 0,
      baseUrl: APP_CONFIG.appUrl,
      bookCdnUrl: APP_CONFIG.bookCdnUrl,
      urlCMS: APP_CONFIG.urlPlatformCmsImg,
      base64Define: BASE_64_DEFINE,
      optionsSliderMain: this.settingSwiperMain()
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['slidesMain', 'isOpenSlideshow', 'slideIndexVisible']),
    swiper () {
      return this.$refs.swiper_slideshow.swiper
    }
  },
  created() {
    window.addEventListener('keyup', this.onKeyup)
  },
  mounted () {
    this.checkSlidePositionActive()
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.onKeyup)
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetVisibleSlideshow', 'acSetLinkAudioVieoViewer', 'acSetSlideVisibleIndex']),

    checkSlidePositionActive () {
      this.slideIndexVisible > 0 && this.swiper.slideTo(this.slideIndexVisible, 1000, false)
    },

    renderStyleLink (data) {
      if (data.type === 'video' || data.type === 'audio') {
        return {
          position: 'absolute',
          top: `${(data.top/data.layout.height) * 100}%`,
          left: `${(data.left/data.layout.width) * 100}%`,
          width: `${(data.width/data.layout.width) * 100}%`,
          height: `${(data.height/data.layout.height) * 100}%`
        }
      }
    },

    closeSlideshow () {
      this.acSetVisibleSlideshow(false)
    },

    prevSlide () {
      this.slideIndexVisible > 0 && this.acSetSlideVisibleIndex(this.slideIndexVisible - 1)
    },

    nextSlide () {
      this.slideIndexVisible < this.slidesMain.length - 1 && this.acSetSlideVisibleIndex(this.slideIndexVisible + 1)
    },

    onKeyup (e) {
      if (e.keyCode === 37 || e.keyCode === 39) {
        this.swiper.slideTo(this.slideIndexVisible, 1000, false)
      } else if (e.keyCode === 27) {
        // ESC
        this.closeSlideshow()
      }
    },

    settingSwiperMain() {
      let self = this;
      return {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: '.slideshow__next',
          prevEl: '.slideshow__prev',
        },
        on: {
          slideChange: function () {
            self.acSetSlideVisibleIndex(this.realIndex)
          }
        }
      }
    },

    handleViewMedia (data) {
      // if (!data.video_src) {
      //   return
      // }
      let link = data.video_src ? data.video_src : data.audio_src
      // if (data.file_uploaded) {
      link = data.file_uploaded ? `${this.baseUrl}/${link}` : `${this.bookCdnUrl}${link}`
      this.acSetLinkAudioVieoViewer(link)
    }

    // handleNextMediaMain (val) {

    // }
  }
}
</script>

<style lang="scss" scoped>
</style>
